import React, { FC, MouseEvent } from "react";
import loans from "assets/images/v2/house-icon.svg";
import settings from "assets/images/v2/gear-icon.svg";
import logout from "assets/images/v2/arrow-left-to-bracket.svg";
import "./ProfileMenuDropdown.scss";
import { openProfile, setLogout, getCurrentUserId } from "features/authSlice";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate } from "react-router-dom";
import { deleteAllFiles } from "utilities/files";
import { useGetMyLoansQuery } from "pages/application/applicationService";

interface MenuItem {
  icon: string;
  label: string;
  onClick: (event: MouseEvent<HTMLDivElement>) => void;
}

type MenuEntry = MenuItem | { isDivider: true };

const ProfileMenuDropdown: FC = () => {
  const userId = useSelector(getCurrentUserId);
  const { data, isLoading, isFetching } = useGetMyLoansQuery(userId);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const menuItems: MenuEntry[] = [
    {
      icon: settings,
      label: "Profile Settings",
      onClick: () => dispatch(openProfile())
    },
    { isDivider: true },
    {
      icon: logout,
      label: "Logout",
      onClick: async () => {
        await deleteAllFiles();
        dispatch(setLogout());
        navigate("/");
      },
    },
  ];

  if ((!(isLoading || isFetching) && data && data.length > 1)) {
    menuItems.unshift({ isDivider: true });
    menuItems.unshift({
      icon: loans,
      label: "My Loans",
      onClick: () => navigate("/my-loans"),
    })
  }

  const isMenuItem = (item: MenuEntry): item is MenuItem => !("isDivider" in item);

  const handleKeyPress = (event: React.KeyboardEvent<HTMLDivElement>, onClick: MenuItem["onClick"]) => {
    if (event.key === "Enter" || event.key === " ") {
      onClick(event as unknown as MouseEvent<HTMLDivElement>);
    }
  };

  return (
    <div className="profile-drop-down">
      {menuItems.map((item, index) => {
        if ("isDivider" in item && item.isDivider) {
          return <div key={`divider-${index}`} className="profile-drop-down__child" />;
        }

        if (!isMenuItem(item)) return null;

        if (item.label === "My Loans") {
          return (
            <NavLink key={item.label} to="/my-loans" state={{ previousPath: location.pathname }} replace className="profile-drop-down__container" end>
              <img className="profile-drop-down__icon" alt={item.label} src={item.icon} />
              <div className="profile-drop-down__label">{item.label}</div>
            </NavLink>
          );
        } else {
          return (
            <div
              key={index}
              className={"profile-drop-down__container"}
              onClick={item.onClick}
              role="button"
              tabIndex={0}
              onKeyPress={(e) => handleKeyPress(e, item.onClick)}
              style={{ cursor: "pointer" }}
            >
              <img className="profile-drop-down__icon" alt={item.label} src={item.icon} />
              <div className="profile-drop-down__label">{item.label}</div>
            </div>
          );
        }
      })}
    </div>
  );
};

export default ProfileMenuDropdown;
